import { defaultListParams, listReducer } from '../../utils/crudUtils';
import {
  getRegistrationsAction,
  setActiveRegistrationsAction,
  searchAgenciesAction,
  getProductsAction,
  getSubscriptionsAction,
  createProfileAction,
  setRegistrationProfileAction,
} from './actions';

export const key = 'Register';

export const initialState = {
  registrationsList: defaultListParams,
  activeRegistration: { step: '1' },
  searchAgencies: defaultListParams,
  products: defaultListParams,
  subscriptions: defaultListParams,
  regError: null,
  regProfile: null,
};

const registrationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getRegistrationsAction.TRIGGER:
    case getRegistrationsAction.SUCCESS:
      return listReducer(state, type, payload, 'registrationsList');
    case getRegistrationsAction.FAILURE:
      return { ...listReducer(state, type, payload, 'registrationsList'), activeRegistration: { step: '1' } };
    case searchAgenciesAction.TRIGGER:
    case searchAgenciesAction.SUCCESS:
    case searchAgenciesAction.FAILURE:
      return listReducer(state, type, payload, 'searchAgencies');
    case getSubscriptionsAction.TRIGGER:
    case getSubscriptionsAction.SUCCESS:
    case getSubscriptionsAction.FAILURE:
      return listReducer(state, type, payload, 'subscriptions');
    case getProductsAction.TRIGGER:
    case getProductsAction.SUCCESS:
    case getProductsAction.FAILURE:
      return listReducer(state, type, payload, 'products');
    case createProfileAction.TRIGGER:
      return { ...state, regError: null };
    case setRegistrationProfileAction.SUCCESS:
      return { ...state, regError: null, regProfile: payload };
    case createProfileAction.SUCCESS:
      return { ...state, regError: null, regProfile: payload };
    case createProfileAction.FAILURE:
      return { ...state, regError: payload };
    case setActiveRegistrationsAction.FAILURE:
      return { ...state, regError: payload };
    case setActiveRegistrationsAction.SUCCESS:
    case setActiveRegistrationsAction.TRIGGER:
      return {
        ...state,
        activeRegistration: { ...payload },
        regError: null,
      };
    default:
      return state;
  }
};

export default registrationReducer;
